if (!customElements.get('oribio-quantity-breaks')) {
  customElements.define(
    'oribio-quantity-breaks',
    class OribioQuantityBreaks extends HTMLElement {
      constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onQuantityUpdate = this.onQuantityUpdate.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.quantityInput = this.querySelector('.oribio-volume__quantity-input');
        this.status = this.querySelector('[data-volume-status]');
        this.selectedQuantity = Number(this.dataset.defaultQuantity) || Number(this.quantityInput?.value) || 1;
        this.addEventListener('change', this.onChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.quantityUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityUpdate);
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }

        this.refreshAvailability();
        this.selectAvailableQuantity(this.selectedQuantity, false);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.quantityUnsubscriber?.();
        this.variantUnsubscriber?.();
      }

      onChange(event) {
        if (!event.target.matches('.oribio-volume__radio')) return;
        this.applyQuantity(Number(event.target.value), true);
      }

      onQuantityUpdate() {
        queueMicrotask(() => {
          this.refreshAvailability();
          this.selectAvailableQuantity(this.selectedQuantity, false);
        });
      }

      onVariantChange({ data }) {
        if (String(data?.sectionId) !== String(this.dataset.sectionId)) return;

        const source = data.html?.getElementById(this.id);
        if (!source) return;

        this.querySelectorAll('.oribio-volume__radio').forEach((radio) => {
          const sourceRadio = source.querySelector(`.oribio-volume__radio[value="${radio.value}"]`);
          const label = this.querySelector(`label[for="${radio.id}"]`);
          const sourceLabel = source.querySelector(`label[for="${radio.id}"]`);

          if (!sourceRadio || !label || !sourceLabel) return;
          radio.disabled = sourceRadio.disabled;
          if (sourceRadio.dataset.totalFormatted) {
            radio.dataset.totalFormatted = sourceRadio.dataset.totalFormatted;
          }
          label.innerHTML = sourceLabel.innerHTML;
        });

        this.dataset.variantAvailable = source.dataset.variantAvailable;
        this.refreshAvailability();
        this.selectAvailableQuantity(this.selectedQuantity, false);
      }

      refreshAvailability() {
        if (!this.quantityInput) return;

        const min = Number(this.quantityInput.min) || 1;
        const step = Number(this.quantityInput.step) || 1;
        const ruleMin = Number(this.quantityInput.dataset.min) || 1;
        const totalMax = this.quantityInput.dataset.max === undefined
          ? null
          : Number(this.quantityInput.dataset.max);
        const cartQuantity = Number(this.quantityInput.dataset.cartQuantity) || 0;
        const availableMaximum = totalMax === null ? null : totalMax - cartQuantity;
        const variantAvailable = this.dataset.variantAvailable === 'true';

        this.querySelectorAll('.oribio-volume__radio').forEach((radio) => {
          const quantity = Number(radio.value);
          const violatesIncrement = (quantity - ruleMin) % step !== 0;
          radio.disabled =
            !variantAvailable ||
            quantity < min ||
            violatesIncrement ||
            (availableMaximum !== null && quantity > availableMaximum);
        });
      }

      selectAvailableQuantity(preferredQuantity, announce) {
        let radio = this.querySelector(`.oribio-volume__radio[value="${preferredQuantity}"]:not(:disabled)`);
        radio = radio || this.querySelector('.oribio-volume__radio:not(:disabled)');
        if (!radio) {
          this.setQuantityUnavailable();
          return;
        }

        radio.checked = true;
        this.selectedQuantity = Number(radio.value);
        this.restoreQuantitySubmit();
        this.applyQuantity(Number(radio.value), announce);
      }

      applyQuantity(quantity, announce) {
        const radio = this.querySelector(`.oribio-volume__radio[value="${quantity}"]:not(:disabled)`);
        if (!radio || !this.quantityInput) return;

        this.selectedQuantity = quantity;
        this.quantityInput.value = String(quantity);
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

        const price = this.closest('.oribio-buybar')?.querySelector('.oribio-buybar__price');
        if (price) {
          price.textContent = radio.dataset.totalFormatted;
          price.classList.remove('hidden');
        }

        if (announce && this.status) {
          this.status.textContent = `${quantity} ${quantity === 1 ? 'unidad seleccionada' : 'unidades seleccionadas'}, total ${radio.dataset.totalFormatted}`;
        }
      }

      setQuantityUnavailable() {
        const submit = this.closest('product-info')?.querySelector('.product-form__submit');
        const price = this.closest('.oribio-buybar')?.querySelector('.oribio-buybar__price');

        if (submit && !submit.disabled) {
          submit.disabled = true;
          submit.setAttribute('aria-disabled', 'true');
          this.disabledSubmitForQuantity = true;
        }
        price?.classList.add('hidden');
        if (this.status) this.status.textContent = 'No hay una cantidad disponible para esta variante.';
      }

      restoreQuantitySubmit() {
        if (!this.disabledSubmitForQuantity || this.dataset.variantAvailable !== 'true') return;

        const submit = this.closest('product-info')?.querySelector('.product-form__submit');
        submit?.removeAttribute('disabled');
        submit?.removeAttribute('aria-disabled');
        this.disabledSubmitForQuantity = false;
      }
    }
  );
}
